<template>
  <form @submit.prevent="submitForm">
    <div class="form-floating mb-3">
      <input
        type="text"
        class="form-control rounded-3"
        id="username"
        placeholder="Enter a username"
        v-model="username"
        @blur="validateField('username')"
        :class="{ 'is-invalid': isUsernameInvalid }"
      />
      <label for="username">Username</label>
    </div>

    <!-- 仅在注册表单中显示邮箱输入字段 -->
    <div class="form-floating mb-3" v-if="formType === 'register'">
      <input
        type="email"
        class="form-control rounded-3"
        id="email"
        placeholder="Enter your email"
        v-model="email"
        @blur="validateField('email')"
        :class="{ 'is-invalid': isEmailInvalid }"
      />
      <label for="email">Email address</label>
    </div>

    <div class="form-floating mb-3">
      <input
        type="password"
        class="form-control rounded-3"
        id="password"
        placeholder="Create a password"
        v-model="password"
        @blur="validateField('password')"
        :class="{ 'is-invalid': isPasswordInvalid }"
      />
      <label for="password">Password</label>
    </div>

    <BaseButton class="special" color="SPECIAL" type="submit">
      {{ buttonText }}
    </BaseButton>
  </form>
</template>

<script>
import BaseButton from "@/components/global/BaseButton.vue";

export default {
  components: {
    BaseButton,
  },
  props: {
    formType: {
      type: String,
      default: "register", // 默认为注册
    },
  },
  data() {
    return {
      username: "",
      email: "",
      password: "",
      formSubmitted: false,
      isUsernameInvalid: false,
      isEmailInvalid: false,
      isPasswordInvalid: false,
    };
  },
  computed: {
    buttonText() {
      return this.formType === "register" ? "Sign up" : "Log in";
    },
  },
  methods: {
    validateField(field) {
      if (field === "username") {
        this.isUsernameInvalid = !this.username.trim();
      } else if (field === "email" && this.formType === "register") {
        this.isEmailInvalid = !this.email.trim();
      } else if (field === "password") {
        this.isPasswordInvalid = !this.password.trim();
      }
    },
    submitForm() {
      this.formSubmitted = true;
      if (
        this.isUsernameInvalid ||
        this.isEmailInvalid ||
        this.isPasswordInvalid
      ) {
        // 如果有验证失败的字段，不提交表单
        return;
      }
      // 提交表单
      this.$emit("submit", {
        username: this.username,
        email: this.email,
        password: this.password,
      });
    },
  },
};
</script>

<style scoped>
.form-control:focus {
  border-color: #702dff; /* 设置焦点时边框颜色为紫色 */
  box-shadow: 0 0 0 0.1rem #ae76ff; /* 设置焦点时的阴影颜色 */
}
.form-control:focus {
  border-color: #702dff;
  box-shadow: 0 0 0 0.1rem #ae76ff;
}
</style>
